import axios from 'axios'
import ShopifyCart from "./ShopifyCart"

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

const ajaxURL = '/api/courses/html';
const ajaxURLTrial = '/api/courses_trial/html';
const ajaxURLUpcoming = '/api/courses_upcoming/html';
const ajaxURLDiscounted = '/api/courses_discounted/html';
const ajaxURLExamsList = '/api/exams_list/html';

export default class CourseList {
}
CourseList.filterWrapper = document.getElementById('course-list-filter')
CourseList.coursesWrapper = document.getElementById('courses-grid')
CourseList.filtersList = document.querySelectorAll('.course-filter')

CourseList.getFilterState = function () {
    let filterState = {}

    filterState.language = CourseList.filterWrapper.dataset.language
    filterState.location = CourseList.filterWrapper.dataset.location

    Array.prototype.forEach.call(CourseList.filtersList, function (el, i) {
        const activeOption = el.querySelector('.course-filter-option.active')
        if (activeOption) {
            filterState[el.dataset.filter] = activeOption.dataset.option
        }
    });

    filterState.only_real = 'n'
    if (CourseList.filterWrapper.dataset && CourseList.filterWrapper.dataset.onlyReal) {
        filterState.only_real = CourseList.filterWrapper.dataset.onlyReal
    }

    return filterState
}


CourseList.loadItems = async function (options) {
    CourseList.coursesWrapper.classList.add('opacity-2')

    options.exit_url = window.location.href

    options.locale = document.documentElement.lang

    let url = ajaxURL
    if (CourseList.filterWrapper.dataset.trial && CourseList.filterWrapper.dataset.trial === 'Y') {
        url = ajaxURLTrial
    }
    if (CourseList.filterWrapper.dataset.funnel && CourseList.filterWrapper.dataset.funnel === 'trial') {
        url = ajaxURLTrial
    }
    if (CourseList.filterWrapper.dataset.funnel && CourseList.filterWrapper.dataset.funnel === 'upcoming') {
        url = ajaxURLUpcoming
    }
    if (CourseList.filterWrapper.dataset.funnel && CourseList.filterWrapper.dataset.funnel === 'discounted') {
        url = ajaxURLDiscounted
    }
    if (CourseList.filterWrapper.dataset.funnel && CourseList.filterWrapper.dataset.funnel === 'exams') {
        url = ajaxURLExamsList
    }

    let coursesHtml = await axios.get(url, {params: options})
    CourseList.coursesWrapper.innerHTML = coursesHtml.data
    CourseList.filterItems(options)
    CourseList.coursesWrapper.classList.remove('opacity-2')
    CourseList.bindCourseHandlers()
}

CourseList.adjustFilterOptions = function (options) {
    const levelFilter = CourseList.filterWrapper.querySelector('ul.level')
    let levelOptions = levelFilter.querySelectorAll('li');
    Array.prototype.forEach.call(levelOptions, function (el, i) {
        el.classList.remove('d-none')
    });

    switch (options.type) {
        case 'conversation':
            levelFilter.querySelector('.a1').classList.add('d-none')
            levelFilter.querySelector('.a2').classList.add('d-none')
            levelFilter.querySelector('.b1').classList.add('d-none')
            levelFilter.querySelector('.c2').classList.add('d-none')
            switch (options.level) {
                case 'a1':
                case 'a2':
                case 'b1':
                case 'c2':
                    options.level = 'b2'
                    levelFilter.querySelector('.b2 a').click()
                    break;
            }
            break

        case 'cambridge':
        case 'goethe':
            if (options.level === 'a1') {
                options.level = 'a2'
                levelFilter.querySelector('.a2 a').click()
            }
            levelFilter.querySelector('.a1').classList.add('d-none')
            break;

        default:
            break;
    }

    return options
}

CourseList.filterItems = function (options) {
    CourseList.coursesWrapper.classList.add('opacity-2')

    const items = CourseList.coursesWrapper.querySelectorAll('.grid-item')
    Array.prototype.forEach.call(items, function (el, i) {
        if (options.time && !el.classList.contains(options.time)) {
            el.classList.add('d-none')
        } else {
            el.classList.remove('d-none')
        }
    });

    setTimeout(() => {
        CourseList.coursesWrapper.classList.remove('opacity-2')
    }, 100)
}

if (CourseList.filterWrapper) {
    CourseList.filterWrapper.addEventListener('click', (event) => {
        if (!event.target.matches('.course-filter-option'))
            return

        event.preventDefault()

        if (event.target.matches('.course-filter-option.active'))
            return

        const filter = event.target.parentNode.parentNode
        const currentActiveOptions = filter.querySelectorAll('.course-filter-option.active')
        Array.prototype.forEach.call(currentActiveOptions, function (el, i) {
            el.classList.remove('active')
        });
        event.target.classList.add('active')

        let options = CourseList.getFilterState()
        options = CourseList.adjustFilterOptions(options)

        if (filter.dataset.filter === 'time') {
            CourseList.filterItems(options)
        } else {
            CourseList.loadItems(options)
        }
    })
}

CourseList.bindCourseHandlers = function () {
    ShopifyCart.bindPageHandlers()
    let courseInstances = CourseList.coursesWrapper.querySelectorAll('.collapse')
    Array.prototype.forEach.call(courseInstances, function (el, i) {
        let $collapsible = $(el)

        $collapsible.on('hide.bs.collapse', function (event) {
            // Collapsed
            const targetId = $(this).attr("id");
            const $container = $('[data-target="#' + targetId + '"],[href="#' + targetId + '"]');
            $(".ico.vox-mdi-minus", $container).removeClass('vox-mdi-minus').addClass('vox-mdi-plus');
            $(".ico.vox-mdi-chevron-down", $container).removeClass('vox-mdi-chevron-down').addClass('vox-mdi-chevron-right');
            $(".reservation-top", $container).show().css('visibility', 'visible'); // Also using "visibility" because "display" might be overriden by bootstrap classes
            event.stopPropagation();
        })

        $collapsible.on('show.bs.collapse', function (event) {
            // Expanded
            const targetId = $(this).attr("id");
            const $container = $('[data-target="#' + targetId + '"],[href="#' + targetId + '"]');
            $(".ico.vox-mdi-plus", $container).removeClass('vox-mdi-plus').addClass('vox-mdi-minus');
            $(".ico.vox-mdi-chevron-right", $container).removeClass('vox-mdi-chevron-right').addClass('vox-mdi-chevron-down');
            $(".reservation-top", $container).hide().css('visibility', 'hidden'); // Also using "visibility" because "display" might be overriden by bootstrap classes
            event.stopPropagation();
        })
    });
}

if (CourseList.coursesWrapper) {
    CourseList.bindCourseHandlers()
    let options = CourseList.getFilterState()
    options = CourseList.adjustFilterOptions(options)
}
